import { render, staticRenderFns } from "./MaternityConsult.vue?vue&type=template&id=4ecdc813"
import script from "./MaternityConsult.vue?vue&type=script&lang=js"
export * from "./MaternityConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports